async function fetchReviewData(skuList) {
 const options = {
    method: 'GET',
    headers: { accept: 'application/json' }
  };

  try {
    const res = await fetch(
      `https://api.reviews.io/product/rating-batch?store=jimmyjoy.com&sku=${skuList}`,
      options
    );

    const data = await res.json();

    let totalRatings = 0;
    let weightedSum = 0;

    data.forEach(item => {
      const avg = parseFloat(item.average_rating);
      const count = Number(item.num_ratings);

      if (!isNaN(avg) && count > 0) {
        weightedSum += avg * count;
        totalRatings += count;
      }
    });

    const overallAverage =
      totalRatings > 0 ? (weightedSum / totalRatings).toFixed(2) : 0;

    const result = {
      total_ratings: totalRatings,
      average_rating: Number(overallAverage)
    };

    return result;

  } catch (err) {
    console.error('Error fetching review data:', err);
    return null;
  }

}

async function updateProductRatings() {
// console.log('Updating product ratings...');
  const cards = document.querySelectorAll('.AB-collection-page-jan-2026 .JJ-collection-product-grid-cro[data-skus]');

  for (const card of cards) {
    const skuList = card.dataset.skus;
    const ratingEl = card.querySelector('.jj-product-card__rating');
    const textEl = card.querySelector('.rating-text');

    if (!skuList || !ratingEl || !textEl) continue;

    try {
        
      const result = await fetchReviewData(skuList);
      if (result.total_ratings > 0) {
        textEl.textContent = `${result.average_rating}/5 (${result.total_ratings})`;
        ratingEl.hidden = false;
      }else{
        ratingEl.classList.add('hide-rating');
      }
    } catch (e) {
      console.error('Reviews.io error:', e);
    }
  }
}

document.addEventListener('DOMContentLoaded', updateProductRatings);


function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  // Reset heights
  elements.forEach(el => el.style.height = 'auto');

  let rows = {};
  elements.forEach(el => {
    const top = el.getBoundingClientRect().top;
    rows[top] = rows[top] || [];
    rows[top].push(el);
  });

  Object.values(rows).forEach(row => {
    const maxHeight = Math.max(...row.map(el => el.offsetHeight));
    row.forEach(el => el.style.height = `${maxHeight}px`);
  });
}

    const filterItemsButton = document.querySelectorAll('.collection-filter__item');
    filterItemsButton.forEach(item => {
        item.addEventListener('click', function() {
            setTimeout(function(){
                runMatchHeightMobile()
            },50)
        })
    })

function runMatchHeightMobile() {
  if (window.innerWidth <= 767) {
    // console.log('button clicked collection-----')
    matchHeight('.AB-collection-page-jan-2026 .jj-line-aligned');
    matchHeight('.AB-collection-page-jan-2026 .jj-subtitle');
    // matchHeight('.AB-collection-page-jan-2026 .jj-product-card__per-meal-price');
    
  } else {
    // Reset height when leaving mobile
    document.querySelectorAll('.AB-collection-page-jan-2026 .jj-line-aligned').forEach(el => {
      el.style.height = 'auto';
    });
    document.querySelectorAll('.AB-collection-page-jan-2026 .jj-subtitle').forEach(el => {
      el.style.height = 'auto';
    });
    // document.querySelectorAll('.AB-collection-page-jan-2026 .jj-product-card__per-meal-price').forEach(el => {
    //   el.style.height = 'auto';
    // });
  }
}

// Run on load & resize
window.addEventListener('load', runMatchHeightMobile);
window.addEventListener('resize', runMatchHeightMobile);

function applyStyles(selector, styles) {
  const elements = document.querySelectorAll(selector);

  elements.forEach(el => {
    Object.entries(styles).forEach(([property, value]) => {
      el.style[property] = value;
    });
  });
}

function matchWidgetHeight(selector) {
  const widgets = document.querySelectorAll(selector);
  if (!widgets.length) return;

  // Reset height
  widgets.forEach(widget => {
    widget.style.height = "auto";
    widget.style.display = "block";
  });

  let maxHeight = 0;

  widgets.forEach(widget => {
    maxHeight = Math.max(maxHeight, widget.offsetHeight);
  });

  widgets.forEach(widget => {
    widget.style.minHeight = `${maxHeight}px`;
  });
}

function updateJudgeMeHeight() {
  matchWidgetHeight(".JJ-collection-product-grid-cro .jdgm-widget");
}

window.addEventListener("load", updateJudgeMeHeight);
window.addEventListener("resize", updateJudgeMeHeight);